import React from 'react';
import { motion } from 'framer-motion';
import { Plane } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary';
  href?: string;
  target?: string;
  rel?: string;
  onLinkClick?: () => void;
  showIcon?: boolean;
}
const variantClasses: Record<'primary' | 'secondary', string> = {
  primary: 'text-white bg-orange-500 hover:bg-orange-600 shadow-lg shadow-orange-500/30 border-2 border-orange-500 hover:border-orange-600',
  secondary: 'text-blue-950 bg-white hover:bg-slate-50 shadow-sm border-2 border-blue-950'
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  href,
  target,
  rel,
  onLinkClick,
  showIcon = true,
  ...props
}: ButtonProps) {
  const baseClasses = `inline-flex items-center justify-center gap-3 px-8 py-4 text-lg font-extrabold uppercase tracking-wide rounded-xl transition-colors duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 ${variantClasses[variant]}`;
  const content = <>
      <span data-id="element-48" data-mp="i2mla2emdvme">{children}</span>
      {showIcon && variant === 'primary' && <Plane className="w-[1.1em] h-[1.1em] shrink-0" aria-hidden="true" data-id="element-49" data-mp="3b4aqk4j4taf" />}
    </>;
  if (href) {
    return <motion.a href={href} target={target} rel={rel ?? (target === '_blank' ? 'noopener noreferrer' : undefined)} onClick={onLinkClick} className={`${baseClasses} ${className}`} whileHover={{
      scale: 1.03
    }} whileTap={{
      scale: 0.97
    }} transition={{
      duration: 0.12,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-50" data-mp="88nrbqop9i5j">
        {content}
      </motion.a>;
  }
  return <motion.button className={`${baseClasses} ${className}`} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.97
  }} transition={{
    duration: 0.12,
    ease: [0.23, 1, 0.32, 1]
  }} {...props} data-id="element-51" data-mp="1eqsvr5y83i8l">
      {content}
    </motion.button>;
}